export const routeMetaData = {
  login: {
    title: 'Sign In',
    icon: '',
    link: '/login',
  },
  applicationForm: {
    title: 'Application Form',
    icon: '',
    link: '/application-form',
  },
  forgetPsw: {
    title: 'Forget Password',
    icon: '',
    link: '/forgot-password',
  },
  createAccount: {
    title: 'Create Account',
    icon: '',
    link: '/create-account',
  },
  myAccount: {
    title: 'My Account',
    icon: 'person',
    link: '/my-account',
  },
  requests: {
    title: 'Data Access Requests',
    icon: 'fact_check',
    link: '/requests',
  },
  accessAndUse: {
    title: 'Access and Use',
    icon: 'password',
    link: '/api-instruction',
  },
} as const;
